import { request } from '@/common';
import { HelperCore } from '@/common/dependencies';
import { makeAutoObservable, runInAction } from 'mobx';

class Store {
  listData = [];
  isFold = false;
  npt = '';
  loadSecondPage = false; //是否加载过第二页
  firstPageSize = 5; //第一页加载5条

  constructor() {
    makeAutoObservable(this);
    // this.getModelList({ size: this.firstPageSize, first: true }); //第一页加载5条
  }
  getModelList = ({ size = 10, first }) => {
    if (first) {
      this.npt = '';
    } else {
      this.loadSecondPage = true;
    }
    request
      .get('/robot/list', {
        params: {
          size,
          //wd,
          npt: this.npt,
          scene: 'recent',
        },
      })
      .then(res => {
        const list = res.data?.list || [];
        runInAction(() => {
          if (first) {
            this.listData = list;
          } else {
            this.listData = HelperCore.uniqueArray(
              [...this.listData, ...list],
              'id'
            );
          }
          this.npt = res.data?.npt || '';
          // if (list.length < size / 2) {
          //   this.npt = '';
          // }
        });
      });
  };
  frontItem = () => {
    //从接口获取最新的一个
    request
      .get('/robot/list', {
        params: {
          size: 1,
          scene: 'recent',
        },
      })
      .then(res => {
        const list = res.data?.list || [];
        const asstInfo = list[0];
        if (!asstInfo) return;
        this.listData.forEach((item, index) => {
          if (item.id == asstInfo.id) {
            this.listData.splice(index, 1);
            return;
          }
        });
        if (!this.npt && this.listData.length == this.firstPageSize) {
          this.isFold = true;
        }
        this.listData.unshift(asstInfo);
      });
  };
  setFold = flag => {
    this.isFold = flag;
  };
  reset() {
    this.listData = [];
    this.isFold = false;
    this.npt = '';
    this.loadSecondPage = false;
    this.firstPageSize = 5; 
  }
}

const modelHistoryStore = new Store();
export default modelHistoryStore;
